"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = [{
  label: 'None',
  value: 'None'
}, {
  label: 'At time of event',
  value: 0
}, {
  label: '5 minutes before',
  value: 5 * 60
}, {
  label: '10 minutes before',
  value: 10 * 60
}, {
  label: '15 minutes before',
  value: 15 * 60
}, {
  label: '30 minutes before',
  value: 30 * 60
}, {
  label: '1 hour before',
  value: 60 * 60
}, {
  label: '2 hours before',
  value: 2 * 60 * 60
}, {
  label: '6 hours before',
  value: 6 * 60 * 60
}, {
  label: '1 day before',
  value: 24 * 60 * 60
}, {
  label: '2 days before',
  value: 2 * 24 * 60 * 60
}];